/** A profile link from what someone typed: a full URL is kept, a @handle becomes the network's address. */
export const socialUrl = (platform, value) => {
  if (!value) return "#";
  if (value.startsWith("http://") || value.startsWith("https://")) return value;
  const username = value.replace(/^@+/, "").trim();
  switch (platform) {
    case "instagram":
      return `https://instagram.com/${username}`;
    case "tiktok":
      return `https://tiktok.com/@${username}`;
    case "youtube":
      return `https://youtube.com/@${username}`;
    case "facebook":
      return `https://facebook.com/${username}`;
    default:
      return value;
  }
};

/** The networks a profile or space can link, in Figma's order. */
export const SOCIAL_NETWORKS = [
  ["instagram", "Instagram"],
  ["tiktok", "TikTok"],
  ["youtube", "YouTube"],
  ["facebook", "Facebook"],
];
